<template>
  <a @click.prevent="LogOutUser">
    <svg xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"/></svg>
    <span v-if="props.text">
      خروج
    </span>
  </a>
</template>
<script setup>
  import { defineProps } from 'vue'
  import { useNotificationStore } from '@/stores/notification'
  import { useAlertStore } from '@/stores/alert'
  import { useUserStore } from '@/stores/user';
  const userStore = useUserStore()
  import router from '@/router'
  const props = defineProps({
    text:Boolean
  })
  const LogOutUser = async () => {
    const res = await userStore.logOut()
    if (res) {
      localStorage.clear();
      sessionStorage.clear()
      window.dispatchEvent(new Event("storage"))
      const notificationStore = useNotificationStore()
      notificationStore.$reset()
      router.push("/")
    } else {
      const alertStore = useAlertStore()
      alertStore.msg='خطا در خروج از حساب';
    }
    return true;
  }
</script>
<style scoped>
  svg{
    height: 100%;
    width: auto;
  }
</style>